// Opening the Terms / Privacy pages from anywhere in the app.
//
// Inside the Flutter shell a plain <a target="_blank"> loads the page over the
// app with no chrome and no way back - the user has to force-quit. The shell
// already has a proper in-app browser (the one Settings uses, with the X at the
// top left); it just has to be asked for it by name. On the web there is no
// shell, so a new tab is still the right answer.
import { event } from "./event";

// From the page's own surface check (public/index.html). The old
// "isFlutterInAppWebViewReady" storage key is wiped by the app on logout, so on
// the signup screen it said "browser" inside the app.
const isFlutterShell = () => {
  try {
    if (window.QushiSurface) return window.QushiSurface.surface !== "browser";
    return localStorage.getItem("isFlutterInAppWebViewReady") === "true";
  } catch (e) {
    return false;
  }
};

// `key` must match the event names the native shell already handles for the
// same two documents in Settings.
export const openLegalLink = (key, url) => {
  if (!url) return;
  if (isFlutterShell()) {
    event(key, url);
    return;
  }
  const newTab = window.open();
  if (!newTab) return;
  newTab.opener = null;
  newTab.location.href = url;
};
